module.exports = __webpack_public_path__ + "assets/img/ic-make.40a45f46.svg";